module.exports = __webpack_public_path__ + "img/smile.c10d1dfc.jpg";